import React, { useState, useEffect } from 'react';
import { Table, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getDownloadStatistics } from '../../services/api';
import toast from 'react-hot-toast';

const DownloadStatistics = ({ setTitle }) => {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setTitle('EarthVerse CRM - 下載統計');
    fetchStatistics();
  }, [setTitle]);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const fetchedStatistics = await getDownloadStatistics();
      setStatistics(fetchedStatistics);
    } catch (error) {
      console.error('Error fetching download statistics:', error);
      toast.error('Failed to fetch download statistics. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: '經銷商名稱',
      dataIndex: 'dealer_name',
      key: 'dealer_name',
      sorter: (a, b) => a.dealer_name.localeCompare(b.dealer_name),
    },
    {
      title: '使用者資訊',
      key: 'user_info',
      render: (_, record) => `${record.user_id} - ${record.user_name}`, // 合併 user_id 和 user_name
      sorter: (a, b) =>
        `${a.user_id} - ${a.user_name}`.localeCompare(`${b.user_id} - ${b.user_name}`), // 排序基於合併結果
    },
    {
      title: '總下載次數',
      dataIndex: 'total_download_count',
      key: 'total_download_count',
      sorter: (a, b) => a.total_download_count - b.total_download_count,
      render: (size) => size.toLocaleString('en-US'), // 格式化數字顯示
    },
    {
      title: '總下載大小 (GB)',
      dataIndex: 'total_download_size',
      key: 'total_download_size',
      sorter: (a, b) => a.total_download_size - b.total_download_size,
      render: (size) => size.toLocaleString('en-US'), // 格式化數字顯示
    },
  ];

  const filteredStatistics = statistics.filter((stat) =>
    stat.dealer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    stat.user_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="statistics-list-container">
      <h2>下載統計</h2>
      <div className="statistics-actions" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Input
          placeholder="Search dealers or users..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: 300, marginBottom: 16 }}
        />
      </div>
      <Table
        dataSource={filteredStatistics}
        columns={columns}
        rowKey={(record) => `${record.dealer_id}-${record.user_id}`}
        pagination={{ pageSize: 20 }}
        loading={loading}
      />
    </div>
  );
};

export default DownloadStatistics;
